export default __webpack_public_path__ + "static/logo-0b998d634019da0058bb5cf6de9f1da4.svg";